<script lang="ts">
	//Design system components
	import { Button, Modal, Text, Container, Icon, Alert } from '@Shelly/shelly-design-system';
	import type { AlertPropsTypes, ButtonPropsTypes } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar } from '../helpers/utilities';

	export let showModal = true;
	export let props: {
		title?: string;
		name?: string;
		text?: string;
		alert?: {
			heading?: string;
			type?: AlertPropsTypes['type'];
		};
		value?: string;
		button_1?: string;
		button_1_variant?: ButtonPropsTypes['variant'];
		button_2?: string;
		callback?: () => void;
	};
</script>

<Modal {showModal} on:close={() => (showModal = false)} title={props.title}>
	<svelte:fragment slot="content">
		<Container padding="0">
			<div class="d-flex align-items-center flex-direction-column">
				<Icon class="mb-xs text-danger" icon="fak fa-light-factory-reset" size="xxl" />
				{#if props.name}
					<Text class="mb-s text-bold text-center">{props.name}</Text>
				{/if}
				{#if props.text}
					<Text class="width-full mb-m">{props.text}</Text>
				{/if}
				{#if props.alert.heading}
					<Alert class="width-full" heading={props.alert.heading} type={props.alert?.type} />
				{/if}
			</div>
			<slot />
		</Container>
	</svelte:fragment>

	<div slot="footer" class="d-flex justify-content-end">
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			variant="secondary"
			on:click={() => {
				showModal = false;
			}}
		>
			{capFirstChar(props.button_2)}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			responsiveSize={{
				sm: 'm',
			}}
			variant={props.button_1_variant || 'primary'}
			on:click={() => {
				showModal = false;
				props.callback();
			}}
		>
			{capFirstChar(props.button_1)}
		</Button>
	</div>
</Modal>
